import React from 'react';
import PropTypes from 'prop-types';

import Conversation from 'models/conversation';
import { H1 } from 'components/common/headers';
import CustomerConversationCard from 'components/lib/customer_conversation_card/customer_conversation_card';
import CustomerProfile from 'models/customer_profile';

function CombineCurrentCustomer({ conversation, profile, latestConversationItem, taskCount }) {
  const { name, email, phone, address } = profile;

  return (
    <div className="customerCombine-currentCustomer-wrapper">
      <div className="customerCombine-currentCustomer">
        <H1 data-aid="customerCombine-currentCustomer-heading">Combine Customers</H1>
        <span className="customerCombine-currentCustomer-subheading">Current customer</span>
        <CustomerConversationCard
          profile={{ name, email, phone, address }}
          conversation={conversation}
          conversationItem={latestConversationItem}
          taskCount={taskCount}
        />
      </div>
    </div>
  );
}

CombineCurrentCustomer.propTypes = {
  conversation: PropTypes.instanceOf(Conversation),
  profile: PropTypes.instanceOf(CustomerProfile).isRequired,
  latestConversationItem: PropTypes.string.isRequired,
  taskCount: PropTypes.number.isRequired,
};

export default CombineCurrentCustomer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer_combine/combine_current_customer.jsx